export default __webpack_public_path__ + "static/media/dinner.a7993e5a.svg";